import { AuthHttpError } from "./auth-http-error";

function normalizeBaseUrl(baseUrl: string) {
  return baseUrl.replace(/\/$/, "");
}

async function postJson<TBody extends object>(
  baseUrl: string,
  path: string,
  body: TBody,
): Promise<void> {
  const res = await fetch(`${normalizeBaseUrl(baseUrl)}${path}`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    throw new AuthHttpError(res.status, res.statusText, res.url);
  }
}

export type LoginBody = { email: string; password: string };

export type MailLanguage = "de" | "en" | "bilingual";

export type PasswordResetRequestBody = {
  to: string;
  /** Defaults to bilingual on the server when omitted. */
  language?: MailLanguage;
};

export type ResetPasswordBody = { nonce: string; newPassword: string };

export async function authLogin(baseUrl: string, body: LoginBody) {
  await postJson(baseUrl, "/auth/login", body);
}

export async function authLogout(baseUrl: string) {
  const res = await fetch(`${normalizeBaseUrl(baseUrl)}/auth/logout`, {
    method: "POST",
    credentials: "include",
  });
  if (!res.ok) {
    throw new AuthHttpError(res.status, res.statusText, res.url);
  }
}

export async function authRequestPasswordReset(
  baseUrl: string,
  body: PasswordResetRequestBody,
) {
  await postJson(baseUrl, "/auth/password-reset", body);
}

export async function authResetPassword(baseUrl: string, body: ResetPasswordBody) {
  await postJson(baseUrl, "/auth/reset-password", body);
}
